<!-- 晒单有礼 -->
<template>
  <div class="create-singles-Step marginClass">
    <!-- 头部返回 -->
    <div class="backBox">
      <img class="pointer" @click="returnBack()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStep != 0 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStep == 0">
        <div class="activeEdit_bottom" v-loading="loading">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div class="template-wz pointer" v-for="(item, index) in tempSwitchList" @click="handleTem(item, index)"
                :key="item.id" :class="{ activeTem: index == tabActive }" v-show="item.isVisible">
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div class="temImg_content" @click="handleOpen()" style="border: 1px solid rgba(123,97,255,0.15);">
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div class="temImg_content_wz" style="background: rgba(123, 97, 255, 0.05);"></div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img class="imgs" style="width:100%;" :src="item.templateUrl || item.imageUrl" alt="" />
                  <img v-if="item.days" class="temImg_content_img_free" src="@/assets/thdImg/common/free.svg" alt=""
                    srcset="" />
                  <div v-if="item.days" class="temImg_content_img_time">倒计时：{{ item.days }}</div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.title || item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div class="temImg_content_bgshadow_code qrCodeIMG" id="qrCodeIMG1" ref="qrCodeIMG1"></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div class="temImg_content_bgshadow_btn pointer" @click="nextStepKai(item)">
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep" v-if="localStep != 0">
        <div class="card-point tipBg">
          <div class="card-rule"></div>
          <div class="card-connet">
            <p>
              订单完成后发放奖励
            </p>
          </div>
        </div>
        <el-form :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="120px">
          <div class="newsInfo">基本信息</div>
          <el-form-item label="活动名称:" required>
            <el-input v-model="ruleForm.activityName" maxlength="30" show-word-limit placeholder="请填入活动名称"
              style="width: 400px" :disabled="isStart"></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker prefix-icon="no_icon" v-model="ruleForm.startTime" type="datetime" placeholder="开始日期"
                size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px" class="time1" @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)" :clearable="false"
                :disabled="isStart">
              </el-date-picker>
              <div class="time_to_text time_to_text_copy">至</div>
              <el-date-picker prefix-icon="no_icon" v-model="ruleForm.endTime" type="datetime" placeholder="结束日期"
                size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px" class="time2" @change="activityTimeChange"
                :picker-options="pickerOptionsValueEnd"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)" :clearable="false"
                :disabled="activityData.isStart">
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" v-if="!isStart" @click="clearTime"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #7B61FF">{{ timeDay }}</span> 天
              <span style="color: #7B61FF">{{ timeOut }}</span> 小时
              <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <!-- <el-form-item label="活动对象:" required>
            <el-radio-group v-model="ruleForm.objectType" :disabled="isStart">
              <el-radio :label="0" :disabled="isStart">不限</el-radio>
              <el-radio :label="1" :disabled="isStart">会员身份</el-radio>
              <el-radio :label="2" :disabled="isStart">指定人群</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <!-- <el-form-item label="会员等级:" required v-if="ruleForm.objectType == 1"> -->
          <el-form-item label="活动参与对象:" required>
            <el-checkbox-group v-model="ruleForm.allowLevel" @change="infoNameschange" :disabled="isStart">
              <el-checkbox label="-1" name="allowLevel">全部</el-checkbox>
              <el-checkbox label="0" name="allowLevel" :disabled="ruleForm.allowLevel == -1">非会员</el-checkbox>
              <el-checkbox v-for="(item, index) in levelList" :key="index" :label="index + 1 + ''" name="allowLevel"
                :disabled="ruleForm.allowLevel == -1">{{ item }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="Plus会员身份:" required>
            <el-radio v-model="ruleForm.plusObject" :label="0" :disabled="isStart">不限</el-radio>
            <el-radio v-model="ruleForm.plusObject" :label="1" :disabled="isStart">Plus会员</el-radio>
            <el-radio v-model="ruleForm.plusObject" :label="2" :disabled="isStart">非plus会员</el-radio>
            <div style="color:red">注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
            </div>
          </el-form-item>
          <el-form-item label="活动条件:">
            <el-checkbox v-model="ruleForm.condFollow" :disabled="isStart">关注店铺后方可参与活动</el-checkbox>
          </el-form-item>

          <div class="newsInfo">资料信息</div>
          <el-form-item label="领奖需提交:" required>
            <!-- 上部分 -->
            <el-checkbox-group v-model="infoNames">
              <el-checkbox label="复选框 A" v-for="(item, index) in infoNamesList" :key="index" :label="item"
                :disabled="(defaultInfos.includes(item) && infoNames.includes(item) && ruleForm.isAutoReleasePrize && awardSettingsLsit[0].prizeType == 3)||(item=='订单号'&&isStart)"></el-checkbox>
            </el-checkbox-group>
            <!-- 下部分 -->
            <el-checkbox-group v-model="informationOne">
              <div v-for="(item, index) in itemArrOne.slice(0, 10)" :key="index">
                <el-checkbox :label="item.informationmation ? item.informationmation : index"
                  :value="item.informationmation" :key="item.informationmation" v-bind="{
                    checked: itemArrOne[index].informationmationOne + '' ? true : false,
                  }">
                  <el-select v-model="item.informationmationSelect" placeholder="请选择"
                    style="width: 100px;margin-right: 12px;" @change="handleSelect($event, index)">
                    <el-option v-for="msg in msgOptions" :key="msg.value" :label="msg.label" :value="msg.value">
                    </el-option>
                  </el-select>
                  <el-input v-model="item.informationmationOne" placeholder="自定义名称" maxlength="12"
                    @blur="onInfoBlur($event, item)"> </el-input>
                  <div style="display: inline-block;margin-left: 10px;position: relative;" @click="deleteaInfo(index)">
                    <img style="position: absolute;top: -13px;" src="@/assets/thdImg/pages/delet.svg" />
                  </div>
                </el-checkbox>
              </div>
              <el-button type="text" @click="perfectAdd" style="border: 1px solid #7B61FF;height: 26px;"
                :disabled="itemArrOne.length == 9">+ 添加 </el-button>
              <el-button type="text" style="color: #909399; margin-left: -20px; cursor: default">（{{
                itemArrOne.length ? itemArrOne.length : 0 }}/9）</el-button>
            </el-checkbox-group>
          </el-form-item>

          <!-- 选择订单号才显示 -->
          <template v-if="infoNames.includes('订单号')">
            <div class="newsInfo">订单规则</div>
            <el-form-item label="参与规则:" required>
              <div class="rule_box">
                <el-form-item class="rule_box_middle">
                  <div>所下订单需满足如下条件</div>
                  <el-form-item label="下单时间:" required>
                    <div style="margin-left:10px" class="my_select_time">
                      <el-date-picker prefix-icon="no_icon" v-model="ruleForm.startOrderTime" type="datetime"
                        placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 190px; font-size: 12px" default-time="00:00:00" class="time1"
                        @change="orderChange" :clearable="false" :disabled="isStart">
                      </el-date-picker>
                      <div class="time_to_text time_to_text_copy">至</div>
                      <el-date-picker prefix-icon="no_icon" v-model="ruleForm.endOrderTime" type="datetime"
                        placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 195px; font-size: 12px" default-time="23:59:59" class="time2"
                        @change="orderChange" :clearable="false" :disabled="isStart">
                      </el-date-picker>
                      <i class="el-icon-circle-close date_icon1" v-if="!isStart" @click="clearOrderTime()"></i>
                      <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
                    </div>
                  </el-form-item>

                  <el-form-item label="购买指定商品:" required class="zindexBox">
                    <el-radio-group v-model="ruleForm.skuType" :disabled="isStart || backgroundOpacity" @change="onFilterTypeChange">
                      <el-radio :label="0" :disabled="isStart">全部商品</el-radio>
                      <el-radio :label="1" :disabled="isStart">指定商品</el-radio>
                    </el-radio-group>
                    <el-button class="zindexBox" :disabled="ruleForm.skuType == 0 || backgroundOpacity" :style="{
                      width: itemListForFilter.length > 0 ? '110px' : '60px', 'margin-left': '16px'
                    }" @click="exposureProductsFiter">
                      {{
                        itemListForFilter.length != ""
                          ? "已选择" + "(" + itemListForFilter.length + "个)"
                          : "+添加"
                      }}
                    </el-button>
                    <draggable v-if="itemListForFilter.length > 0" v-model="mainImagelistFilter" chosen-class="chosen"
                      :scroll="true" animation="150" force-fallback="true" @start="isDraggingFilter = true"
                      @end="onEndFilter" style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
                      filter=".unmover">
                      <transition-group type="transition">
                        <div v-for="(item, index) in mainImagelistFilter" :key="item.skuId"
                          style="display: inline-block; position: relative" class="show_upImg2 unmover"
                          :class="isStart ? 'unmover' : ''">
                          <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                          <div class="delectPosible" v-if="!isStart && !backgroundOpacity">
                            <!-- <span class="delectSort">拖动排序</span> -->
                            <img src="@/assets/thdImg/pages/delet.svg" @click.stop="delecFilter(index)"
                              class="delectIcom" />
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                  </el-form-item>
                  <el-form-item label="订单金额:">
                    大于等于&nbsp;
                    <el-input v-model="ruleForm.minOrderAmt"
                      @input="ruleForm.minOrderAmt = getNumberData(1, $event, 1, 0, 99999.99)" style="width:140px"
                      placeholder="请输入" :disabled="isStart"></el-input>&nbsp; 元 &nbsp;
                      <el-tooltip class="item" effect="dark" content="订单金额：是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                      <span class="el-icon-question" style="color: #ccc;"></span>
                    </el-tooltip>
                    <div style="color:red;display: inline-block">注意：由于接口原因，pop支持统计实付金额，自营仅支持统计订单金额。</div>
                  </el-form-item>
                  <el-form-item label="商品件数:">
                    大于等于&nbsp;
                    <el-input v-model="ruleForm.minItemCnt"
                      @input="ruleForm.minItemCnt = getNumberData(1, $event, 0, 1)" style="width:140px"
                      placeholder="请输入" :disabled="isStart"></el-input>&nbsp; 件&nbsp;
                  </el-form-item>
                  <el-form-item label="订单状态:">
                    <el-radio-group v-model="ruleForm.orderStatus" :disabled="isStart">
                      <el-radio :label="0">已完成</el-radio>
                      <el-radio :label="1">已付款（下单付款后即可统计）</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="订单限制:" required>
              <el-form-item label="同一类型活动不可重复参与" class="order-limit-column">
                <div class="apply-row-tip tip-start">
                  <el-switch v-model="ruleForm.isSameTypeRepeatable"  :disabled="isStart"></el-switch>
                  <div class="tip">注意：开启后，若有多个晒单有礼活动，用户使用同一订单号，先参与其他晒单有礼活动后，不可再使用此订单号参与本次活动</div>
                </div>
              </el-form-item>
              <el-form-item label="不同类型活动不可重复参与" class="order-limit-column">
                <div class="apply-row-tip tip-start">
                  <el-switch v-model="ruleForm.isDiffTypeRepeatable" :disabled="isStart"></el-switch>
                  <div class="tip">注意：开启后，若有多个解锁类型活动，用户使用同一订单号，先参与其他解锁类型活动后，不可再使用此订单号参与本次活动<br>
                    解锁类型活动包括：首购有礼、复购有礼、下单有礼、下单抽奖、预售有礼、预售抽奖
                  </div>
                </div>
              </el-form-item>
            </el-form-item>
          </template>

          <div class="newsInfo">奖品设置</div>
          <el-form-item label="奖品设置:" required>
            <el-table :data="awardSettingsLsit" style="width: 1100px; border: 1px solid #f0f0f0;margin-top: 15px;"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }">
              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" style="color:#7B61FF;cursor: pointer;"
                    @click="selectPacket(scope.$index, scope.row)">选择奖品</span>
                </template>
              </el-table-column>
              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.prizeType | filterPrizeType }}</span>
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price"></el-table-column>
              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.title" maxlength="12" :disabled="(scope.row.prizeType != 3||scope.row.isGoodManage) || isStart"
                    show-word-limit style="width: 240px" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖品数量" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.totalAmount"
                    :disabled="isStart"
                    @input.native="(e) => (scope.row.totalAmount = handleCheckputn(e, scope.row, 'jindou'))"
                    @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1), prizeNum(scope.row, 1)"
                    maxlength="10" class="inputcount" show-word-limit style="width: 150px" placeholder="请输入"
                    @blur="beAdd(scope.row)"></el-input>
                </template>
              </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
               <el-table-column label="操作" v-if="isStart" width="200">
                <template slot-scope="scope">
                  <el-button type="text"
                  style="margin-left: 5px"
                  @click="itemAddNum('awardSettingsLsit', scope.$index)"
                  >增加奖品数量</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <div class="newsInfo">参与审核设置</div>
          <el-form-item label="参与次数:" required class="prize-stock-item fvertical">
            <div>本次活动中每个人最多参与{{ ruleForm.applyNum }}次</div>
          </el-form-item>
          <el-form-item label="奖品库存不足可参与:" required class="prize-stock-item fvertical">
            <div class="apply-row-tip fvertical">
              <el-switch v-model="ruleForm.isAllowParticipateForPrizeLow" :disabled="isStart"></el-switch>
              <div class="tip">注意：开启后，奖品库存不足用户也可提交资料。但通过审核人数不会超过奖品实际人数。未开启时，库存不足时停止信息收集</div>
            </div>
          </el-form-item>
          <el-form-item label="审核结果展示:" required class="prize-stock-item fvertical">
            <div class="apply-row-tip fvertical">
              <el-switch v-model="ruleForm.isShowAuditResult" :disabled="isStart"></el-switch>
              <div class="tip">注意：开启时，用户可以在活动详情页查看是否通过审核及查看审核备注</div>
            </div>
          </el-form-item>
          <el-form-item label="自动收集地址:" required class="prize-stock-item fvStart">
            <div class="apply-row-tip fvStart">
              <el-switch v-model="ruleForm.isAutoReleasePrize" @change="onAutoPrizeSwitch"
                :disabled="isStart"></el-switch>
              <div class="tip">注意：未开启时，用户通过审核后需要再次进入活动页面填写收货地址信息<br>
                开启时，审核通过后自动根据用户填写信息生成收货地址<br>
                仅针对实物奖品生效</div>
            </div>
          </el-form-item>
          <orderShopInfo :isShowMoreSet="false" v-model="customerPaperwork"/>
          <div class="newsInfo">曝光商品</div>
          <el-form-item label="曝光商品:">
            <div>
              <el-checkbox v-model="ruleForm.isExposureItem" @change="exposureSwitchChange" :disabled="isStart || backgroundOpacity">
                是否添加曝光商品
              </el-checkbox>
              <el-button style="width: 155px; margin: 0 15px;display: inline-block;"
                :class="[{ add_btn1: ruleForm.isExposureItem }, 'zindexBox']" @click="exposureProducts"
                :disabled="!ruleForm.isExposureItem || isStart || backgroundOpacity">
                {{ "添加曝光商品" + itemListFor.length ? "(" + itemListFor.length + "/20" + ")" : '' }}
              </el-button>
              <el-radio-group v-model="ruleForm.priceType" :disabled="ruleForm.isExposureItem == false || isStart || backgroundOpacity">
                <el-radio :label="0">显示京东价</el-radio>
              </el-radio-group>
            </div>
            <draggable v-if="itemListFor.length > 0" v-model="mainImagelist" chosen-class="chosen" :scroll="true"
              animation="150" force-fallback="true" @start="isDragging = true" @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;" filter=".unmover">
              <transition-group type="transition">
                <div v-for="(item, index) in mainImagelist" :key="item.skuId"
                  style="display: inline-block; position: relative" class="show_upImg2"
                  :class="isStart ? 'unmover' : ''">
                  <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                  <div class="delectPosible" v-if="!isStart">
                    <span class="delectSort">拖动排序</span>
                    <img src="@/assets/thdImg/pages/delet.svg" @click.stop="delec(index)" class="delectIcom" />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <div class="newsInfo">分享设置</div>
          <el-form-item label="小程序分享标题:" required label-width="125">
            <el-input type="text" style="width: 400px;margin-left:8px;" show-word-limit v-model="ruleForm.shareTitle"
              :maxlength="28" :disabled="isStart"></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介:" required label-width="125">
            <el-input type="text" style="width: 400px;margin-left:8px;" show-word-limit
              v-model="ruleForm.shareIntroduce" :maxlength="28" :disabled="isStart"></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片:" required label-width="130">
            <div class="miniAppPic" style="margin-left:16px;">
              <div class="top">
                <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                  :before-upload="beforeUpload1" :on-success="handleUpload1" :disabled="isStart">
                  <el-button size="mideal" class="returnBtn">自定义上传</el-button>
                </el-upload>
                <span class="reset" @click="picUrlReset1" :disabled="isStart">重置</span>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips11">
                  <p>建议上传尺寸：200px * 200px</p>
                  <p>图片大小：1MB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <div class="newsInfo">活动规则</div>
          <el-form-item label="规则内容:" required>
            <div class="rule-content">
              <el-input type="textarea" class="rule-textarea" style="width: 543px" resize="none"
                v-model="ruleForm.activityRulesText" :maxlength="5001"></el-input>
              <div class="prosi" style="color: #909399">
                （{{ ruleForm.activityRulesText.length ? ruleForm.activityRulesText.length - 1 : 0 }}/5000）
              </div>
              <div>
                <el-button type="primary" class="generate" plain @click="generateRule" :disabled="isStart || backgroundOpacity">
                  生成规则
                </el-button>
                <span class="desc">
                  <i class="el-alert__icon el-icon-info"></i>
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </span>
              </div>
            </div>
          </el-form-item>
          <actInfoSetting :valueRow="activeValue" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <el-button v-show="!itemId" class="returnBtn" size="medium" @click="clickLocalStep()">{{ backgroundOpacity ?
        "返回列表" :
        "返回上一步" }}</el-button>
      <el-button class="returnBtn createBtn" @click="saveDraft" v-if="hasDraftBtn">存为草稿</el-button>
      <template v-if="!backgroundOpacity">
        <el-button v-show="!itemId" v-if="isSave" class="keepBtn" type="primary" size="medium" @click="saveEdit"
          v-preventReClick>保存并完成设置</el-button>
      </template>
      <el-button v-show="itemId" class="returnBtn" size="medium" @click="cancelEdit">取消</el-button>
      <el-button v-show="itemId" class="keepBtn" type="primary" size="medium">保存并完成设置</el-button>
    </div>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor ref="selectGo" :isShow="selectGoodsState" @close="selectGoodsClose"
      :selectGoods="selectGoodsArr" :moduleType="true" :skuSearch="true" :xianz="true" :disabled="backgroundOpacity" :isSupportVirtualGroup="true">
    </selectGoodsMonitor>

    <!-- 选择奖品 -->
    <selectProduct ref="selectProductAward" :isShowFirst="isShowFirst" :echoDate="echoDate" :actId="valueRow" :num="1"
      :JingdouCount="JingdouCount" @choose-shop="getTheDataAward"> </selectProduct>

    <!-- 指定购买商品 -->
    <selectGoodsMonitor ref="selectGoFilter" v-if="selectGoodsStateFilter" :isShow="selectGoodsStateFilter" @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr" :isClear="isStart" :moduleType="true" :skuSearch="true" :xianz="false" 
      :hasSelectGoods="hasSelectGoods"
      :disabled="backgroundOpacity">
    </selectGoodsMonitor>

    <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>
  </div>
</template>

<script>
import dailyLimitConfig from "@/components/dailyLimitConfig.vue";
import {
  hdTaskTemplateGroup,
  sellerImage
} from "@/api/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import selectProduct from "./select_product";
import draggable from "vuedraggable";
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
import { saveSinglesActivity, getActivityDetail } from '@/api/integralCenter/politely.js'
import { getTaobaoItemListSku } from "@/api/analysis/ware-controller";
import { updateCommon } from "@/api/integralCenter/integralTask";
import addPrizeNum from "./components/add-prize-num.vue";

export default {
  name: 'postOrders',
  components: { selectGoodsMonitor, selectProduct, draggable, addPrizeNum , dailyLimitConfig},
  props: {
    /**0，1 复制为0*/
    stepNum: {
      type: Number,
      default: 0,
    },
    /**活动信息 */
    activityData: {
      type: Object,
    },
    /**活动详情 */
    valueRow: {
      type: Object,
      default: () => ({})
    },
    /**活动类型标识 */
    activeValue: {
      type: [Number, String],
      default: 0
    },
    /**表示查看 */
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },

    isSave: {
      type: Boolean,
      default: true,
    },

    itemId: {
      type: [String, Number],
      default: ''
    },
    /**表示草稿 */
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      customerPaperwork: {},
      isKeyActivity: 0,
      placementPosition: [],
      // 回显已经保存过的商品
      hasSelectGoods: [],
      localStep: this.stepNum,
      localStepNum: this.activityData.id,
      loading: false,
      fromLoading: false,
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      tabActive: 0,
      giftList: [], // 礼包模板
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      navItem: {}, //当前点击的模板类型

      ruleForm: {
        activityName: '',
        startTime: '', //活动开始时间
        endTime: '', //活动结束时间
        objectType: 0, //活动对象
        allowLevel: ["-1"], //会员等级
        plusObject: 0, //plus会员身份
        condFollow: false, // 是否需要关注店铺

        startOrderTime: "", //订单开始时间
        endOrderTime: "", //订单结束时间
        skuType: 0, //购买指定商品 //商品类型 0全部 1指定 2排除
        minOrderAmt: '',
        minItemCnt: '',
        orderStatus: 0,
        isSameTypeRepeatable: true, //统一类型活动不可重复参与
        isDiffTypeRepeatable: false, //统一类型活动不可重复参与


        applyNum: 1, //参与次数
        isAllowParticipateForPrizeLow: true, //奖品库存不足可参与
        isShowAuditResult: true, //审核结果展示
        isAutoReleasePrize: false, //实物自动发放

        isExposureItem: false, //是否显示曝光商品
        priceType: 0, //0：显示京东价 1：显示促销价

        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片

        activityRulesText: "", //生成规则


      },
      isStart: false,
      isDraft: false, //草稿操作

      infoNamesList: ['姓名', '订单号', '评价截图', '手机号', '地址', '详细地址'],
      infoNames: ['订单号'],
      defaultInfos: ['姓名', '手机号', '地址', '详细地址'],
      msgOptions: [
        {
          label: "文本",
          value: 1
        },
        {
          label: "图片",
          value: 2
        }
      ],
      infoCheckType: 1,
      isShowAddRow: false,
      inputText: '',
      itemArrOne: [],  //自定义字段列表
      informationOne: [],  //选择


      itemListForFilter: [], //指定商品列表
      mainImagelistFilter: [],
      isDraggingFilter: false,
      selectGoodsStateFilter: false,
      selectGoodsFilterArr: [],
      draggingIdFilter: [],//有拖拽时要传的ID顺序

      awardSettingsLsit: [  // 奖品设置列表
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          // awardMinScore: null,
          // awardMaxScore: null,
          // awardLevel: null,
        },
      ],
      JingdouCount: {
        prizeCount: 0,
      },
      isShowFirst: false,
      awardIndex: 0,
      echoDate: {}, //当前选中的奖品设置行

      selectGoodsState: false,
      selectGoodsArr: [],
      itemListFor: [], //曝光商品列表
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      draggingId: [], //有拖拽时要传的ID顺序


      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.endTime).valueOf() - 24 * 60 * 60 * 1000
          );
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.startTime).valueOf()
          );
        },
      },

      levelList: [], //会员等级列表

      joinBlackList: false,
      checked: false,

      templateId: 0, //模板id

      itemArr: [], //选择奖品弹窗里用到
      sharePic: '', //默认分享图

      toAddItem:{},
      toAddBelong: "",
      toAddIndex: 0,
      isShowAddNum:false,
    };
  },

  filters: {
    filterPrizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      }
      else if (num == "10") {
        result = "礼品卡";
      } else if (num == "14") {
        result = "实物（随单发）";
      }
      return result;
    },

  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMGNew();
        });
      }
    },
  },

  computed: {
    ...mapState(["venderType"]),
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow.id || this.activityData.isCopy;
    }
  },
  created() {
    console.log('activityData11>>', this.activityData)
    console.log('backgroundOpacity>>', this.backgroundOpacity)
    console.log('isStart>>', this.activityData.isStart)
    console.log('copy>>', this.activityData.isCopy)
    console.log('valueRow>>', this.valueRow)
    console.log('isDraftEdit>>', this.isDraftEdit);
    this.isStart = this.activityData.isStart ? true : false;
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`

    // 新增活动默认时间
    if (JSON.stringify(this.valueRow) == '{}') {
      this.ruleForm.startTime = this.$getDate(30, 0)[0]
      this.ruleForm.endTime = this.$getDate(30, 25)[1]
      this.activityTimeChange();
    }
    if (this.valueRow.id) {
      this._getActivityDetail();
    }
  },
  mounted() {
    this.getLevel();
    this.hdTaskTemplateGroup();
    // //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  methods: {
   // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    async _getActivityDetail() {
      console.log('详情>>')
      console.log('id>>', this.valueRow.id)
      const res = await getActivityDetail(this.valueRow.id)
      console.log('详情>>', res)
      if (res.code == 1) {
        let data = res.data || {};
        this.ruleForm.activityName = data.activityName;

        this.ruleForm.startTime = data.startTime;
        this.ruleForm.endTime = data.endTime;
        this.activityTimeChange();

        this.ruleForm.allowLevel = data.allowLevel.split(',');
        this.ruleForm.condFollow = data.condFollow ? true : false;

        //复制活动时 活动规则清空
        if (!this.activityData.isCopy) {
          this.ruleForm.activityRulesText = data.ruleDescription;
        }

        this.ruleForm.isExposureItem = data.isExposureItem ? true : false; //曝光商品
        this.itemListFor = this.ruleForm.isExposureItem ? data.itemList : [];
        this.ruleForm.priceType = data.priceType;
        this.selectGoodsArr = this.itemListFor;
        this.mainImagelist = this.itemListFor;
        // 店铺名称类型回显
        this.customerPaperwork = data.ruleDto.customerPaperwork ? JSON.parse(data.ruleDto.customerPaperwork) : {};

        let ruleDto = data.ruleDto
        //订单规则 (复制活动时 订单规则清空)
        if (!this.activityData.isCopy && ruleDto.orderRule) {
          this.ruleForm.startOrderTime = ruleDto.orderRule.startTime;
          this.ruleForm.endOrderTime = ruleDto.orderRule.endTime;
          this.ruleForm.skuType = ruleDto.orderRule.skuType;
          this.ruleForm.minOrderAmt = ruleDto.orderRule.minOrderAmt;
          this.ruleForm.minItemCnt = ruleDto.orderRule.minItemCnt;
          this.ruleForm.orderStatus = ruleDto.orderRule.orderStatus ? ruleDto.orderRule.orderStatus : 0;
          this.ruleForm.isSameTypeRepeatable = ruleDto.orderRule.isSameTypeRepeatable;
          this.ruleForm.isDiffTypeRepeatable = ruleDto.orderRule.isDiffTypeRepeatable;
          if (ruleDto.orderRule.skuIds && ruleDto.orderRule.skuIds.length) {
            this._getTaobaoItemListSku(ruleDto.orderRule.skuIds);
          }
        }


        //分享设置信息
        this.ruleForm.plusObject = ruleDto.plusObject;
        this.ruleForm.shareTitle = ruleDto.shareTitle;
        this.ruleForm.shareIntroduce = ruleDto.shareIntroduce;
        this.ruleForm.sharePic = ruleDto.sharePic

        //审核设置 (复制活动时 参与审核设置清空)
        if (!this.activityData.isCopy) {
          this.ruleForm.isAllowParticipateForPrizeLow = ruleDto.auditRule.isAllowParticipateForPrizeLow;
          this.ruleForm.isShowAuditResult = ruleDto.auditRule.isShowAuditResult;
          this.ruleForm.isAutoReleasePrize = ruleDto.auditRule.isAutoReleasePrize;
        }

        //资料信息
        this.infoNames = ruleDto.infoNames;
        this.itemArrOne = ruleDto.staticInfoNames.length ? ruleDto.staticInfoNames.map(item => {
          return {
            informationmationSelect: item.type,
            informationmationOne: item.name
          }
        }) : []

        // 奖品设置 (复制活动时 奖品清空)
        if (!this.activityData.isCopy) {
          if (data.pointActivityPrizeDTO && data.pointActivityPrizeDTO.id) {
            let pointActivityPrizeDTO = {
              ...data.pointActivityPrizeDTO,
            };
            if (pointActivityPrizeDTO.prizeType == 1) {
              pointActivityPrizeDTO.singleAmount = 1;
            } else if (pointActivityPrizeDTO.prizeType == 2 || pointActivityPrizeDTO.prizeType == 4) {
              pointActivityPrizeDTO.price = pointActivityPrizeDTO.singleAmount;
            } else {
              pointActivityPrizeDTO.singleAmount = 1;
            }
            pointActivityPrizeDTO.singleAmount = 1;
            this.awardSettingsLsit = [pointActivityPrizeDTO]
          }
        }
        // 是否重点活动
        this.isKeyActivity = data.isKeyActivity||0;
        this.placementPosition = data.placementPosition ? data.placementPosition.split(',') : ["SHOP"];

      }
    },

    // 根据sku查询对应商品信息
    async _getTaobaoItemListSku(skuIds) {
      const res = await getTaobaoItemListSku({
        current: 1,
        size: 9999999,
        skuIdStr: skuIds.join(',')
      })
      if (res.code == 1) {
        let list = res.data.records || [];
        this.itemListForFilter = list;
        this.mainImagelistFilter = list;
        this.selectGoodsFilterArr = list;
        this.hasSelectGoods = JSON.parse(JSON.stringify(list));
      }
    },


    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入活动名称");
        return;
      }

      if (this.isDraftEdit) {
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        }).catch(()=> {
          this.isDraft = false;
        })
      } else {
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        }).catch(()=> {
          this.isDraft = false;
        })
      }
    },
    // 点击完成设置
    saveEdit() {
      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      if (!this.infoNames.length) {
        this.$message.warning("请选择领奖需要提交的资料信息");
        return;
      }

      if (this.itemArrOne.length) {
        let isHasEmpty = this.itemArrOne.some(item => !item.informationmationOne)
        if (isHasEmpty) {
          this.$message.warning("请完善自定义信息");
          return;
        }
      }

      // 资料信息选择了订单号才检验订单规则
      if (this.infoNames.length && this.infoNames.includes('订单号')) {
        if (!this.ruleForm.startOrderTime || !this.ruleForm.endOrderTime) {
          this.$message.warning("请输入下单时间");
          return;
        }

        if (!this.ruleForm.startOrderTime || !this.ruleForm.endOrderTime) {
          this.$message.warning("请输入下单时间");
          return;
        }

        if (this.ruleForm.skuType == 1 && !this.itemListForFilter.length) {
          this.$message.warning("请选择指定商品");
          return;
        }
        // if (!this.ruleForm.minOrderAmt) {
        //   this.$message.warning("请输入订单金额");
        //   return;
        // }
      }

      let isPrizeFlag = this.awardSettingsLsit.some(item => !item.prizeType)
      let isTotalFlag = this.awardSettingsLsit.some(item => !item.totalAmount)
      if (isPrizeFlag) {
        this.$message.warning("请填写奖品");
        return;
      }
      if (isTotalFlag) {
        this.$message.warning("请填写奖品数量");
        return;
      }

      // if(!this.useValidateMoreActSet(this)) {
      //   return;
      // }

      if (this.ruleForm.isExposureItem && !this.itemListFor.length) {
        this.$message.warning("请选择曝光商品");
        return;
      }

      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }

      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }

      if (!this.ruleForm.sharePic) {
        this.$message.warning("小程序分享图片不能为空");
        return;
      }

      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 发布
    async handleDialogCloseAnoth() {
      let obj = {
        activityName: this.ruleForm.activityName,
        startTime: this.ruleForm.startTime,
        endTime: this.ruleForm.endTime,
        allowLevel: this.ruleForm.allowLevel.join(','),
        condFollow: this.ruleForm.condFollow,

        ruleDescription: this.ruleForm.activityRulesText,

        isExposureItem: this.ruleForm.isExposureItem, //曝光商品
        itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
        priceType: this.ruleForm.priceType,
        // 是否重点活动
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(','),
      }

      // 自定义信息
      let staticInfoNames = this.itemArrOne.map(item => {
        return {
          type: item.informationmationSelect,
          name: item.informationmationOne
        }
      })
      // 指定商品skuId
      let skuIdsArr = this.itemListForFilter.map(item => item.skuId)
      let orderRule = {
        startTime: this.ruleForm.startOrderTime,
        endTime: this.ruleForm.endOrderTime,
        skuType: this.ruleForm.skuType,
        minOrderAmt: this.ruleForm.minOrderAmt,
        minItemCnt: this.ruleForm.minItemCnt,
        skuIds: this.ruleForm.skuType == 1 ? skuIdsArr : [],
        isSameTypeRepeatable: this.ruleForm.isSameTypeRepeatable,
        isDiffTypeRepeatable: this.ruleForm.isDiffTypeRepeatable,
        orderStatus: this.ruleForm.orderStatus,
      }
      //奖品列表
      let pointActivityPrizeDTO = this.awardSettingsLsit.map((item, index) => {
        let prize = {
          ...item,
          awardLevel: index + 1,
        };
        if (prize.prizeType == 1) {
          prize.quota = item.quota;
          prize.couponType = item.couponType;
          prize.singleAmount = 1;
        } else if (prize.prizeType == 2 || prize.prizeType == 4) {
          prize.singleAmount = item.price;
        } else {
          prize.singleAmount = 1;
        }
        return prize;
      });
      /**奖品信息传2个字段 */
      obj.pointActivityPrizeDTO = pointActivityPrizeDTO.length ? pointActivityPrizeDTO[0] : {}; //奖品列表
      obj.pointActivityPrizeDTOList = pointActivityPrizeDTO.length ? pointActivityPrizeDTO : [];

      let ruleDTO = {
        plusObject: this.ruleForm.plusObject,
        infoNames: this.infoNames, //资料信息
        staticInfoNames: staticInfoNames,

        // orderRule: orderRule, //订单信息
        // 审核设置
        auditRule: {
          isAllowParticipateForPrizeLow: this.ruleForm.isAllowParticipateForPrizeLow,
          isShowAuditResult: this.ruleForm.isShowAuditResult,
          isAutoReleasePrize: this.ruleForm.isAutoReleasePrize,
        },

        shareTitle: this.ruleForm.shareTitle,
        shareIntroduce: this.ruleForm.shareIntroduce,
        sharePic: this.ruleForm.sharePic,
        customerPaperwork: JSON.stringify(this.customerPaperwork),
      }

      if (this.infoNames.includes('订单号')) {
        ruleDTO.orderRule = orderRule; //订单信息
      }

      obj.ruleDTO = ruleDTO;
      // 编辑要传id
      if (this.valueRow.id && !this.activityData.isCopy) {
        obj.pointActivityId = this.valueRow.id;
      }
      // 模板id
      obj.templateId = this.templateId;
      // obj.templateJson = '';

      // 草稿操作
      if (this.isDraft) {
        obj.status = 5;
        obj.isDraft = true;
        obj.pointActivityPrizeDTOList = obj.pointActivityPrizeDTO.prizeType ? obj.pointActivityPrizeDTOList : [];
        if (!obj.pointActivityPrizeDTO.prizeType) delete obj.pointActivityPrizeDTO; //草稿保存时如果奖品没填就不传这个字段
      }

      // 从草稿转活动
      if(this.isDraftEdit && !this.isDraft) {
        obj.createFromDraft = true;
      }
      let res
      if(this.isStart){
        let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: obj.pointActivityPrizeDTOList.map((item) => {
              return {
                ...item,
                prizeId: item.id,
              };
            }),
            isExposureItem: this.ruleForm.isExposureItem, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow,
            ruleDto: obj.ruleDTO,
          };
        res = await updateCommon(params)
      }else{
        res = await saveSinglesActivity(obj)
      }
      if (res.code == 1) {
        console.log('res>>', res)
        if (this.isDraft) {
          this.$emit("returnBack", true);
        } else {
          this.$router.push({
            name: "throw",
            query: {
              id: res.data.id,
              activityType: res.data.activityType,
            },
          });
        }
        this.$message.success(res.message);
      } else {
        if (res.message) {
          this.$message.error(res.message);
        } else {
          this.$message.error(res.data.message);
        }
      }
      console.log('obj>>', obj);
    },

    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    clickLocalStep() {
      // 查看返回列表
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      // 修改也是返回列表
      if (!this.activityData.isCopy && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.activityData.isCopy) {
        this.localStep = 0;
        return
      }
      this.localStep = 0;
      this.localStepNum = 0;
      // this.$emit('titopName', this.activityData.name, false)
    },

    /*********实物自动发放联动变化 */
    onAutoPrizeSwitch(val) {
      if (!this.awardSettingsLsit[0].prizeType) {
        this.$message.warning('需要先选择奖品')
        this.ruleForm.isAutoReleasePrize = false;
        return;
      } else if (this.awardSettingsLsit[0].prizeType != 3) {
        this.$message.warning('非实物无需开启此能力')
        this.ruleForm.isAutoReleasePrize = false;
        return;
      }
      // 开启 & 实物奖品 = 联动勾选姓名、手机号、地址、详细地址，且不可取消
      if (val && this.awardSettingsLsit[0].prizeType == 3) {
        let infoNames = this.infoNames;
        let arr = ['姓名', '手机号', '地址', '详细地址'];
        arr.forEach(item => {
          if(!infoNames.includes(item)) {
            infoNames.push(item)
          }
        })
        this.infoNames = infoNames;
        // console.log('this.infoNames>>',this.infoNames)
      }
    },
    /**********************资料信息部分 */
    onInfoBlur(e, item) {
      let arr = ['用户pin', '用户昵称', '姓名', '订单号', '评价截图', '手机号', '地址', '详细地址'];
      if (arr.includes(item.informationmationOne)) {
        item.informationmationOne = ''
        this.$message.warning('该名称不可使用')
        return
      }
    },
    //自定义信息删除
    deleteaInfo(index) {
      // if (this.isStart) return;
      this.itemArrOne.splice(index, 1);
    },
    handleSelect(val, index) {
      this.itemArrOne[index].informationmationOne = ""
    },

    // 自定义信息
    perfectAdd() {
      if (this.itemArrOne.length) {
        let hasNeedWrite = this.itemArrOne.some(item => !item.informationmationOne)
        if (hasNeedWrite) {
          this.$message.warning('需完善当前字段再新增下一个')
          return
        }
      }
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationSelect: 1, //类型 1文本 2图文
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
      console.log('itemArrOne>>', this.itemArrOne)
    },

    /******************指定商品部分 */
    onFilterTypeChange() {
      this.itemListForFilter = [];
      this.selectGoodsFilterArr = [];
      this.mainImagelistFilter = [];
    },
    // 指定商品删除
    delecFilter(index) {
      this.mainImagelistFilter.splice(index, 1);
      this.itemListForFilter.splice(index, 1);
    },
    // 指定商品区域拖拽
    onEndFilter() {
      this.isDraggingFilter = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelistFilter.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingIdFilter = arr;
      });
    },
    //选择指定商品回调
    selectGoodsCloseFilter(data) {
      console.log(data, 11111);
      if (data) {
        this.itemListForFilter = [];
        this.mainImagelistFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
          this.mainImagelistFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsStateFilter = false;
    },

    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        this.mainImagelistFilter = [];
      }
      // console.log(this.selectGoodsFilterArr, this.itemListForFilter);
      this.$nextTick(()=>{
        this.$refs.selectGoFilter.handleRightCurrentChange(1);
      })
    },
    clearOrderTime() {
      this.ruleForm.startOrderTime = '';
      this.ruleForm.endOrderTime = '';
    },
    //下单时间
    orderChange() {
      let start = new Date(this.ruleForm.startOrderTime).valueOf();
      let end = new Date(this.ruleForm.endOrderTime).valueOf();
      console.log(start)
      console.log(end)
      if (start > end && start && end) {
        this.$message.warning("订单开始时间不能大于订单结束时间");
        this.ruleForm.startOrderTime = '';
        return;
      }
    },

    // 选择奖品回调
    getTheDataAward(data, prizeType) {
      console.log(data, prizeType, '选择奖品弹窗关闭');
      if (prizeType == 1) {
        this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
        this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
        this.awardSettingsLsit[this.awardIndex].quota = data.quota;
        this.awardSettingsLsit[this.awardIndex].assetsId = data.assetsId;
      }
      if (prizeType == 2) {
        this.awardSettingsLsit[this.awardIndex].quantityTotal = data.quantityTotal;
      }
      // if (prizeType == 3) {
      //   this.awardSettingsLsit[this.awardIndex].skuId = data.skuId;
      // }
      if (data.giftType) {
        this.awardSettingsLsit[this.awardIndex].giftType = Number(data.giftType);
      }
      this.awardSettingsLsit[this.awardIndex].price = data.discount || data.singleAmount;
      this.awardSettingsLsit[this.awardIndex].assetsId = Number(data.couponId);
      this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          this.awardSettingsLsit[this.awardIndex].skuId = data.skuId;
          delete this.awardSettingsLsit[this.awardIndex].isGoodManage
        } else {
          this.awardSettingsLsit[this.awardIndex].isGoodManage = data.isGoodManage;
        }
      }
      if (prizeType == 4) {
        this.awardSettingsLsit[this.awardIndex].title = data.discount + "店铺积分";
      } else {
        if (data.name) this.awardSettingsLsit[this.awardIndex].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.awardSettingsLsit[this.awardIndex].singleAmount = data.singleAmount;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8,10].includes(Number(prizeType))) {
        this.awardSettingsLsit[this.awardIndex].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.awardSettingsLsit[this.awardIndex].budgetRemain = data.budgetRemain;
      }
    },

    // 选择奖品
    selectPacket(index, item) {
      if (this.isStart) return;
      if(item.prizeType&&item.prizeType == 14){
        this.$message({
          message: "该奖品类型不支持修改",
          type: "warning",
        });
        return
      }
      this.$refs.selectProductAward.openDialog();
      this.JingdouCount.prizeCount = item.totalAmount;
      this.awardIndex = index;
      this.echoDate = item;
      console.log(item, 111);
    },

    // 活动进行中修改奖品数量
    beAdd(row) {
      console.log(row);
      if (this.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let text1 = '1、活动名称：' + this.ruleForm.activityName;
      let text2_1 = this.ruleForm.startTime && this.ruleForm.endTime ? `${this.ruleForm.startTime}~${this.ruleForm.endTime}` : '--'
      let text2 = '2、活动时间：' + text2_1;
      let levelText = [];
      if (this.ruleForm.allowLevel.length > 0) {
        this.ruleForm.allowLevel.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });
      }
      let text3 = '3、活动参与对象：' + levelText.join(',');
      let plusObjectObj = ['不限', 'Plus会员', '非plus会员']
      let text4 = '4、Plus会员身份：' + plusObjectObj[this.ruleForm.plusObject];
      let text5 = '5、按活动页面要求填写对应信息';
      let text6_1 = `下单时间：${this.ruleForm.startOrderTime}~${this.ruleForm.endOrderTime}；订单金额：大于等于${this.ruleForm.minOrderAmt}元；商品件数：${this.ruleForm.minItemCnt ? this.ruleForm.minItemCnt + '件' : '不限'}`
      let text6 = '6、参与规则：' + text6_1;

      let Arr1 = [
        text1,
        text2,
        text3,
        text4,
        text5,
      ];
      if (this.infoNames.includes('订单号')) Arr1.push(text6)
      let newText = "";
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
        }
      });
      this.ruleForm.activityRulesText = newText;
    },

    // 添加曝光商品回调
    selectGoodsClose(data) {
      if (data) {
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      this.selectGoodsState = false;
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },

    //点击添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },

    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        console.log(this.uploadSize);
        if (this.uploadSize) {
          this.ruleForm.sharePic = res.data;
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      if (this.activityData.isStart) return
      this.ruleForm.sharePic = this.sharePic
    },

    //图片拖拽 
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //曝光商品删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
    },
    //选中改变
    infoNameschange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.allowLevel = ["-1"];
        }
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      let commentStart = new Date(this.ruleForm.startOrderTime).valueOf();
      let invalidateDate = new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();

      if (this.ruleForm.endTime && this.ruleForm.startTime) {
        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(Math.abs(new Date(this.ruleForm.endTime) - new Date(this.ruleForm.startTime)) / 1000 / 60 / 60 / 24);
        //计算小时
        let date3 = new Date(this.ruleForm.endTime).getTime() - new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }
      // 查看不需要校验
      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.ruleForm.endTime = "";
        return;
      }
      if (end && end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (start && end && end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
    },
    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true
        item.title = item.groupName
      })
      this.sellerImage()
    },

    //模板下一步
    nextStepKai(items) {
      // console.log(items);
      //新增判断
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      if (items.id) {
        this.templateId = items.id
      }
      this.$emit("titopName", this.activityData.name, true);
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => { });
    },
    getCodeIMGNew() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg="
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].secondImageUrl,
        });
      }
    },
    // 返回上一步
    returnBack() {
      console.log('kk>>',this.valueRow.id)
      // this.$emit("returnBack");
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStep == 0) this.$emit("returnBack");
      if (this.localStep == 1) this.localStep = 0;
    },

    handleTem(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.sellerImage()
    },

    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },

    // 活动模板
    async sellerImage() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMGNew();
      });
    },


    /*******************工具类 ****************/

    handleCheckputn(e, num = "-1", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (num == "0") {
          if (e.target.value < 1) {
            e.target.value = "";
          }
        }
        if (num == "1") {
          if (e.target.value > 9) {
            e.target.value = "";
          }
          if (this.ruleForm.imgNum == 9) {
            this.ruleForm.videoNum = "";
          }
        }
        if (num == "2") {
          if (e.target.value > 1) {
            e.target.value = "";
          }
        }
        if (num == "5") {
          if (e.target.value < 2 || e.target.value > 5) {
            e.target.value = "";
          }
        }
      } else {
        // pop去掉京豆判断 this.venderType true 自营
        if (this.venderType && num.quantityTotal && num.price && num.totalAmount && num.prizeType == 2) {
          let numTotal = this.$jingdouTotal({ ...num, prizeCount: num.totalAmount });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return num.totalAmount;
        }
      }
    },

    // 京东计划数量计算
    prizeNum(row, type = 1) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8,10].includes(Number(row.prizeType))) {
        if (type == 1) {
          if (Number(row.totalAmount) && (Number(row.totalAmount) > row.budgetRemain)) {
            row.totalAmount = ""
            if (row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
            if (row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
            if (row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
            if (row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
            if (row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
          }
        } else {
          if (Number(row.prizeCount) && (Number(row.prizeCount) > row.budgetRemain)) {
            row.prizeCount = ""
            if (row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
            if (row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
            if (row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
            if (row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
            if (row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
          }
        }
      }
    },

    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
  },
};
</script>

<style lang="scss" scoped>
.fvertical {
  display: flex;
  align-items: center;
}

.fvStart {
  display: flex;
  align-items: flex-start;

}

.create-singles-Step {
  background: #fff;
  .time_to_text_copy {
    background: #fff;
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 0px 35px 0;
  }

  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;

    .card-point {
      width: 100%;
      background: #fffaee;
      border-radius: 4px;
      margin-top: 20px;
      margin-bottom: 20px;
      padding: 12px 0px 12px 20px;
      display: flex;

      .card-rule {
        margin-left: 12px;
        padding-left: 18px;
        width: 28px;
        background: url("../../assets/images/new_icon_reminder.png") no-repeat;
        background-size: 14px 14px;
        margin-top: 4px;
      }

      .card-connet {
        p {
          line-height: 22px;
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }

  .rule_box {
    width: 860px;
    // height: 217px;
    margin-top: 9px;
    background: #fafafa;
    padding-bottom: 10px;
    border-radius: 4px;
    font-size: 14px;

    &_middle {
      padding-top: 10px;
    }

    &_content {
      padding: 0 15px;

      img {
        display: inline-block;
        float: left;
        position: absolute;
        width: 14px;
        height: 14px;
        color: #ffffff;
        margin: 9px 4px 0 3px;
      }

      p {
        padding-left: 21px;
      }
    }
  }

  .apply-row-tip {
    margin-left: 16px;

    .tip {
      color: red;
      margin-left: 16px;
      line-height: 20px;
    }
  }

  .tip-start {
    margin-top: 6px;
    display: flex;
  }

  .add_btn1 {
    cursor: pointer;
    color: #7b61ff;
    border: 1px solid #7b61ff;
    width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(123, 97, 255, 0.1);
    border-radius: 4px;
    margin-top: 8px;
  }

  .miniAppPic {
    position: relative;

    .image-slot {
      width: 100%;
      height: 100%;
      background: #f5f7fa;
      text-align: center;
      padding-top: 43px;

      i {
        font-size: 30px;
        color: #909399;
      }
    }

    .top {
      position: relative;
      left: 8px;
      display: flex;

      .returnBtn {
        border-radius: 4px;
        width: auto;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #7B61FF;
        background: rgba(123, 97, 255, 0.1);
        border: 1px solid #7B61FF;

        &:hover {
          color: #fff;
          background: #7B61FF;
        }
      }

      .reset {
        color: #7b61ff;
        cursor: pointer;
        font-size: 14px;
        margin-left: 15px;
      }
    }

    .bottom {
      position: relative;
      top: 15px;
      margin-left: 115px;

      .elImg {
        width: 120px;
        height: 120px;
        border: 1px dashed #dddddd;
        border-radius: 5px;
      }

      .tips11 {
        position: absolute;
        left: 135px;
        top: 22px;
        line-height: 2;
        color: #aaaaaa;
        font-size: 13px;
      }
    }
  }


  .rule-content {
    width: 570px;
    backgroundcolor: rgba(250, 250, 250, 1);
    padding: 8px;
    position: relative;

    .prosi {
      position: absolute;
      bottom: 45px;
      right: 20px;
    }

    .desc {
      i {
        opacity: 0.7;
        color: #7b61ff;
      }

      color: #999;
    }

    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);    border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
  }

}
</style>
<style lang="scss">
.prize-stock-item {
  min-height:40px;
  .el-form-item__label {
    width: 160px !important;
    line-height: 14px;
  }

  .el-form-item__content {
    margin-left: 0px !important;
  }
}

.order-limit-column {
  .el-form-item__label {
    width: 190px !important;
  }
}

.rule-textarea {
  .el-textarea__inner {
    min-height: 120px!important;
  }
}
</style>
